import { render } from "./CollectImportUsers.vue?vue&type=template&id=47880d55"
import script from "./CollectImportUsers.vue?vue&type=script&lang=js"
export * from "./CollectImportUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__